{
  "name": "calzedonia-budgetmanager",
  "version": "4.0.0",
  "author": "Quix Srl",
  "homepage": "https://ionicframework.com/",
  "scripts": {
    "ng": "ng",
    "start": "npx ng serve --open",
    "start:qas": "npx ng serve --configuration=quality-app --open",
    "start:prod": "npx ng serve --configuration=production-app --open",
    "build": "npx ng build",
    "test": "npx ng test",
    "lint": "npx ng lint",
    "e2e": "npx ng e2e",
    "generate-ios-resources": "npx capacitor-assets generate --assetPath resources",
    "startProjectUi": "npx ng serve --disable-host-check --baseHref=/budgetmanager/",
    "build-ionic": "npx ionic capacitor build ios",
    "capacitor-sync": "npx ionic capacitor sync",
    "build-ionic-prod": "NODE_ENV=production npx ionic capacitor run ios -c production-app",
    "build-ionic-quality": "NODE_ENV=quality npx ionic capacitor run ios -c quality-app",
    "generateLocalService": "npx openapi-generator-cli generate -g typescript-angular -i src/app/apiModule/openapi.yaml -o src/app/apiModule --skip-validate-spec --additional-properties npmName=@quix/requestmanager-api",
    "ios": "NODE_ENV=production npx ionic capacitor run ios -c production-app",
    "sonar": "sonar-scanner",
    "generateAPI": "openapi-generator-cli generate -g typescript-angular -i https://budgetmanagerquality.calzedonia.com/oniverse-budgetmanager/v3/api-docs/oniverse-app -o ./src/app/apiModule --skip-validate-spec --additional-properties npmName=@quix/oniverse-budgetmanager-ui-service"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~21.2.2",
    "@angular/cdk": "~21.2.1",
    "@angular/common": "~21.2.2",
    "@angular/core": "~21.2.2",
    "@angular/forms": "~21.2.2",
    "@angular/platform-browser": "~21.2.2",
    "@angular/platform-browser-dynamic": "~21.2.2",
    "@angular/router": "~21.2.2",
    "@capacitor/app": "^7.1.2",
    "@capacitor/browser": "^7.0.4",
    "@capacitor/core": "^7.6.0",
    "@capacitor/device": "^7.0.4",
    "@capacitor/filesystem": "^7.1.8",
    "@capacitor/ios": "^7.6.0",
    "@capacitor/preferences": "^7.0.4",
    "@capacitor/push-notifications": "^7.0.6",
    "@capacitor/share": "^7.0.4",
    "@capacitor/splash-screen": "^7.0.5",
    "@capacitor/status-bar": "^7.0.5",
    "@ionic/angular": "^7.8.6",
    "@jsverse/transloco": "^7.5.0",
    "@ngrx/signals": "^21.0.1",
    "@sentry/angular": "^10.52.0",
    "air-datepicker": "^3.6.0",
    "angular-oauth2-oidc": "^20.0.0",
    "angular-svg-icon": "^19.1.1",
    "bootstrap": "^5.3.3",
    "date-fns": "^3.6.0",
    "echarts": "^6.0.0",
    "quang": "^21.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~21.2.1",
    "@angular/cli": "~21.2.1",
    "@angular/compiler": "^21.2.2",
    "@angular/compiler-cli": "~21.2.2",
    "@angular/language-service": "~21.2.2",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^7.6.0",
    "@commitlint/cli": "^19.8.0",
    "@commitlint/config-conventional": "^19.8.0",
    "@eslint/js": "^9.22.0",
    "@openapitools/openapi-generator-cli": "^2.7.0",
    "@trivago/prettier-plugin-sort-imports": "^5.2.2",
    "@types/node": "^22.13.10",
    "angular-eslint": "^21.1.0",
    "eslint": "^9.22.0",
    "eslint-config-love": "^117.0.0",
    "husky": "^9.1.7",
    "lint-staged": "^15.4.3",
    "ng-lint-staged": "^12.0.4",
    "ng-packagr": "^21.1.0",
    "prettier": "^3.5.3",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.26.1"
  },
  "overrides": {
    "@stencil/core": "4.12.2"
  },
  "description": "Budget Manager"
}
